import { html, LitElement } from "lit";
import { customElement, property } from 'lit/decorators.js';
import { styleMap } from "lit/directives/style-map.js";

import { constructGridTemplateRows } from "./utils";
import style from './timetable-day.scss';

/**
 * List component containing list of timetable-entry
 */

@customElement('timetable-day')
export class TimetableDay extends LitElement {

    static override styles = style;

    /** Hour to draw timetable from */
    @property({attribute: 'start', type: Number}) startTime = 8;
    /** Last full hour to be drawn on timetable  */
    @property({attribute: 'end', type: Number}) endTime = 16;

    /**
     * Show mini timetable, to be used e.g. as a thumbnail
     * managed by containing usos-timetable
     */
    @property({type: Boolean, reflect: true}) mini = false;

    constructor() {
        super();
        const internals = this.attachInternals();
        internals.role = 'list';
    }

    override render() {
        const hoursStyles = constructGridTemplateRows(this.startTime, this.endTime);
        return html`<div role='presentation' style=${styleMap(hoursStyles)}><slot></slot></div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
      'timetable-day': TimetableDay,
    }
}
